export enum LoudspeakerOutputPath {
	PreDsp = 'PreDsp',
	PostDsp = 'PostDsp'
}
